import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "Container",
  class: "h-100 d-flex flex-column content"
}
const _hoisted_2 = {
  key: 0,
  class: "w-100 d-flex position-absolute"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border mx-auto",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Container_1 = _resolveComponent("Container_1")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.config.general.container.style === 1)
      ? (_openBlock(), _createBlock(_component_Container_1, {
          key: 1,
          config: _ctx.config
        }, null, 8, ["config"]))
      : _createCommentVNode("", true)
  ]))
}